// /src/components/modals/ImovelEditorModal/ImovelEditorModal.jsx

import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useEditorLogic } from './useEditorLogic';
import { EditorLoading, EditorSyncOverlay } from './EditorProcessing';
import { EditorHeader } from './EditorHeader';
import { EditorFooter } from './EditorFooter';
import * as Constants from './EditorConstants';

import Etapa1Identificacao from '../../imovel/cadastro/1EtapaIdentificacao';
import Etapa2Localizacao from '../../imovel/cadastro/2EtapaLocalizacao';
import Etapa3AcervoDigital from '../../imovel/cadastro/3EtapaAcervoDigital';
import Etapa4Especificacoes from '../../imovel/cadastro/4EtapaEspecificacoesNarrativa';
import Etapa5FinanceiroSEO from '../../imovel/cadastro/5EtapaFinanceiroSEO';

export default function ImovelEditorModal({ imovelId, onClose, onUpdateSuccess }) {
    const {
        formData, setFormData, isLoading, isSubmitting, isProcessing,
        handleChange, handleValueChange, handleSubmit, setRemovedImages
    } = useEditorLogic(imovelId, onClose, onUpdateSuccess);

    if (isLoading) return <EditorLoading />;

    return (
        <div className="fixed inset-0 z-[900] flex justify-center items-center p-4 md:p-8 bg-black/80 backdrop-blur-md overflow-hidden">
            <EditorSyncOverlay isVisible={isProcessing} />

            <motion.div 
                initial={{ opacity: 0, y: 20 }} 
                animate={{ opacity: 1, y: 0 }} 
                className="w-full max-w-[1400px] h-[95vh] flex flex-col overflow-hidden rounded-[3rem] border border-[var(--border-color)] shadow-2xl bg-[var(--bg-main)]"
            >
                <EditorHeader formData={formData} onClose={onClose} />

                <form id="editor-form" onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-10 md:p-16 space-y-16 custom-scrollbar pb-40">
                    <Etapa1Identificacao 
                        formData={formData} 
                        handleChange={handleChange} 
                        onValueChange={handleValueChange} // Corrigido para o FormControls
                        currentSubtipos={Constants.SUBTIPOS_ENTREGA} 
                        opcoesNegocio={Constants.OPCOES_NEGOCIO} 
                        opcoesPrincipal={Constants.OPCOES_PRINCIPAL} 
                        promocoesElite={Constants.PROMOCOES_ELITE} 
                    />
                    <Etapa2Localizacao formData={formData} handleChange={handleChange} onAddressFetch={addr => setFormData(p => ({ ...p, ...addr }))} />
                    <Etapa3AcervoDigital formData={formData} handleFileChange={e => setFormData({...formData, [e.target.name]: [...(formData[e.target.name]||[]), ...Array.from(e.target.files)]})} />
                    <Etapa4Especificacoes formData={formData} handleChange={handleChange} />
                    <Etapa5FinanceiroSEO 
                        formData={formData} 
                        handleChange={handleChange} 
                        onValueChange={handleValueChange} // Corrigido para sincronia total
                    />
                </form>

                <EditorFooter onClose={onClose} isSubmitting={isSubmitting} />
            </motion.div>
        </div>
    );
}